module.exports = __webpack_public_path__ + "static/img/lc.ab5653a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BToB/lc.png
// module id = wiAp
// module chunks = 1